import {
	Stack, HStack, Text,
} from '@chakra-ui/react';
import type { Route } from 'next';
import { MdOutlineChevronRight } from 'react-icons/md';

import { NextLinkButton } from '@/modules/navigation';

type HomeSectionWrapperProps = {
	children: React.ReactNode
	ctaText:  string
	href:     Route<string>
	title:    string
};

export const HomeSectionWrapper = ({
	children,
	ctaText,
	href,
	title,
}: HomeSectionWrapperProps) => {
	return (
		<Stack gap="md">
			<HStack alignItems="center" justifyContent="space-between">
				<Text textStyle="h3">
					{title}
				</Text>
				<NextLinkButton
					href={href}
					p={0}
					size="sm"
					variant="outline"
				>
					{ctaText}
					<MdOutlineChevronRight />
				</NextLinkButton>
			</HStack>
			{children}
		</Stack>
	);
};
